import { createRouter, createWebHashHistory } from 'vue-router';
import store from '@/store'

const routes = [
    {
        path: '/',
        redirect: '/home',
        meta: { title: '首页', index: '0' },
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('@/views/home.vue'),
        meta: { title: '首页', index: '0' },
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('@/views/product.vue'),
        meta: { title: '产品', index: '1' },
    },
    {
        path: '/solution',
        name: 'solution',
        component: () => import('@/views/solution.vue'),
        meta: { title: '解决方案', index: '2' },
    },
    {
        path: '/aboutsm',
        name: 'aboutSm',
        component: () => import('@/views/aboutsm.vue'),
        meta: { title: '关于赛鸣', index: '3' },
    },
    {
        path: '/joinus',
        name: 'joinus',
        component: () => import('@/views/joinus.vue'),
        meta: { title: '加入我们', index: '4' },
    }
]
const router = createRouter({
    history: createWebHashHistory(),
    routes
})
// 路由守卫
router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0)
    if (to.meta.title) {
        document.title = to.meta.title + '-赛鸣科技'
    }
    store.commit('navFunc', to.meta.index)
    next()
})

export default router;